import { Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";

import TaskItem from "./components/TaskItem";
import IssueItem from "./components/IssueItem";

const IssueMultiple = ({ close, onEdit, issues, tasks }) => {
  return (
    <div className="calendar-viewer">
      <div className="calendar-viewer__header">
        <Button onClick={close} type="primary" ghost icon={<CloseOutlined />} />
      </div>
      {issues.map((issue) => (
        <IssueItem {...issue} close={close} key={issue.id} />
      ))}
      {tasks.map((task) => (
        <TaskItem {...task} close={close} onEdit={onEdit} key={task.id} />
      ))}
    </div>
  );
};

export default IssueMultiple;
